<template lang="pug">
  .switzerland
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/switzerland-min.jpg"
      )
      span {{ gettext('Switzerland') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content
      div
        p {{ gettext('Государство в Западной Европе. Официальные языки Швейцарии: немецкий, итальянский, французский и частично ретороманский. Не входит в Евросоюз. Экономика Швейцарии одна из самых стабильных в мире. Основными экономическими ресурсами для Швейцарии являются промышленность (пищевая, текстильная, химическая, машиностроение) и торговля.') }}
        p {{ gettext(' Система образования в Швейцарии настолько же продумана и надежна, как и швейцарские банки. А с уровнем швейцарской медицины трудно соперничать любой стране. Работа в Швейцарии на сегодняшний день является одной из наиболее прибыльных по сравнению с другими странами. Эта очень развитая страна, известна своим неповторимым вкусом и изысканностью.') }}
        p {{ gettext('Многих людей работа в Швейцарии привлекает не только благодаря достаточно высоким заработкам, но и комфортным условиям труда. Но важно помнить, что Швейцария очень разборчива в рабочей силе: в основном приветствуется высококвалифицированный персонал, способный принести пользу не только самому работодателю, но и стране в целом.') }}
        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
      div
        .about-boxes
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/visa-rules`")
            span {{ gettext('Visa rules') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-conditions`")
            span {{ gettext('Working conditions') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/accommodation`")
            span {{ gettext('Accommodation') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/healthcare`")
            span {{ gettext('Healthcare') }}
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/switzerland-min.png'})
  },
  name: 'Switzerland',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Switzerland | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/switzerland/index.vue